import {animate, style, transition, trigger} from "@angular/animations";

export const fadeIn = trigger('fadeIn', [
  transition(":enter", [
    style({ opacity: 0 }),
    animate(250, style({opacity: 1}))
  ]),
])

export const fadeOut= trigger('fadeOut', [
  transition(":leave", [
    style({ opacity: 1 }),
    animate(100, style({opacity: 0}))
  ]),
])

export const fadeInSlow = trigger('fadeInSlow', [
  transition(":enter", [
    style({ opacity: 0 }),
    animate(500, style({opacity: 1}))
  ]),
])
